/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2025-07-09 10:22:26
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2025-07-13 15:48:10
 * @FilePath: \gov-construction-industry-association-web\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */


import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history', // 可选: 'hash' | 'history' | 'abstract'
    routes: [
        {
            path: "/",
            name: 'home',
            component: () => import('@/view/index'),
            meta: {
                title: "首页"
            }
        },
        {
            path: "/overview",
            name: 'overview',
            component: () => import('@/view/overview/index'),
            meta: {
                title: "协会概括",
                primaryNav: 'overview',
            }
        },
        {
            path: "/ovDetail",
            component: () => import('@/view/overview/detail'),
            meta: {
                title: "详情"
            }
        },
        {
            path: "/news",
            component: () => import('@/view/news/index'),
            meta: {
                title: "新闻资讯",
                primaryNav: 'news',

            }
        },
        {
            path: "/newsDetail",
            component: () => import('@/view/news/detail'),
            meta: {
                title: "详情"
            }
        },
        {
            path: "/experts",
            component: () => import('@/view/experts'),
            meta: {
                title: "专家库",
                primaryNav: 'experts',

            }
        },
        {
            path: "/expertsDetail",
            component: () => import('@/view/experts/detail'),
            meta: {
                title: "详情",

            }
        },
        {
            path: "/awards",
            component: () => import('@/view/awards'),
            meta: {
                title: "评优评奖",
                primaryNav: 'awards'
            }
        },
        {
            path: "/awardsDetail",
            component: () => import('@/view/awards/detail'),
            meta: {
                title: "详情"
            }
        },
        {
            path: "/downloads",
            component: () => import('@/view/downloads'),
            meta: {
                title: "资料下载",
                primaryNav: 'downloads'
            }
        },
        {
            path: "/party",
            component: () => import('@/view/party'),
            meta: {
                title: "协会党建",
                primaryNav: 'party'

            }
        },
        {
            path: "/partyDetail",
            component: () => import('@/view/party/detail'),
            meta: {
                title: "详情"
            }
        },
        {
            path: "/members",
            component: () => import('@/view/members'),
            meta: {
                title: "会员名录",
                primaryNav: 'members'

            }
        },
        {
            path: "/membersDetail",
            component: () => import('@/view/members/detail'),
            meta: {
                title: "详情"
            }
        },
        {
            path: "/contact",
            component: () => import('@/view/contact'),
            meta: {
                title: "联系我们",
                primaryNav: 'contact'

            }
        },
        {
            path: "/materialPrice",
            component: () => import('@/view/external'),
            meta: {
                title: "材价综合服务",
                primaryNav: 'materialPrice',
                url: 'https://szpt.szlhcia.cn/'

            }
        },
        {
            path: "/materialData",
            component: () => import('@/view/external'),
            meta: {
                title: "材价数据管理",
                primaryNav: 'materialData',
                url: 'https://szlhcj.zjtcn.com/'

            }
        },

    ]
})
